import React, { useEffect, useState } from "react";
import { Box, Typography, Grid } from "@mui/material";
import {
  Button,
  Container,
  Paper,
  TextField,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Navigate, useNavigate, useParams } from "react-router-dom";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import Header from "../../../components/header";
import SideNavbar from "../../../components/sideNavbar";
import PayPalCheckout from "./PayPalCheckout";
import axiosInstance from "../../../services/axiosInstance";

function BillDetails() {
  const navigate = useNavigate();

  const { id } = useParams();
  const userId = localStorage.getItem("userId");
  const [cardDetails, setCardDetails] = useState([]);

  console.log(cardDetails, "cardDetails");

  useEffect(() => {
    getPriceDetails();
  }, []);

  const getPriceDetails = async () => {
    try {
      const res = await axiosInstance.get(
        `${apiEndPointsConfig.getSingleBillPricing}/${id}`
      );
      setCardDetails(res?.data?.data);
    } catch (error) {
      return error;
    }
  };

  return (
    <Box>
      <Box
        component="main"
        sx={{
          ml: { xs: "0px", md: "280px" },
        }}
      >
        <SideNavbar />
        <Header title={"Bill Details"} />
        <Box
          sx={{
            p: 3,
          }}
        >
          <Box>
            <Grid container spacing={0}>
              <Grid item xs={12} md={5}>
                <Paper sx={{ p: 3, bgcolor: "grey.50" }}>
                  <Typography variant="h5" gutterBottom>
                    Your Order
                  </Typography>
                  <Box sx={{ mt: 3 }}>
                    <Grid
                      container
                      justifyContent="space-between"
                      sx={{ mb: 2 }}
                    >
                      <Typography variant="subtitle1" color="text.secondary">
                        {cardDetails?.title}
                      </Typography>
                      <Typography variant="subtitle1" color="text.secondary">
                        TOTAL
                      </Typography>
                    </Grid>
                    <Grid
                      container
                      justifyContent="space-between"
                      sx={{ mb: 2 }}
                    >
                      <Typography>
                        ( {cardDetails?.window} - real agent )
                      </Typography>
                      <Typography>
                        AED {Math.floor(cardDetails?.offer_price)}
                      </Typography>
                    </Grid>

                    <Divider sx={{ my: 2 }} />
                    <Grid
                      container
                      justifyContent="space-between"
                      sx={{ mb: 3 }}
                    >
                      <Typography variant="h6">ORDER TOTAL</Typography>
                      <Typography variant="h6">
                        AED {Math.floor(cardDetails?.offer_price)}
                      </Typography>
                    </Grid>

                    <Box
                      sx={{
                        mt: 5,
                      }}
                    >
                      <PayPalCheckout amount={cardDetails?.offer_price} />
                    </Box>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default BillDetails;
